import { UserSession, IUser } from '@esri/arcgis-rest-auth';
import ConfigService from './configService';
import CookieService from './cookieService';
import ICookie from '../models/ICookie';
import Constants from './constants';

export default class AuthService {
  private static instance: AuthService;
  public session?: UserSession;
  public user: IUser = {};
  

  /**
   * Init user from cookie
   */
   private initUserFromCookie(): void {
    const cookie: ICookie | null = CookieService.getInstance().getCookie();

    if(window.localStorage.getItem(Constants.IUCN_KEEP_SIGNED_IN) === 'on' && cookie && cookie.user && cookie.tokenExpires) {
      //Check token validity
     if(new Date(cookie.tokenExpires) >= new Date()) {
      this.user = cookie.user;
      this.session = UserSession.deserialize(cookie.session);
     } else {
       CookieService.getInstance().destroyCookie();
     }
    }
  }

  /**
   * Check user group
   * @returns 
   */
  private checkUserGroup(): boolean {
    let isOK = false;

    if(this.user && this.user.groups) {
      if(this.user.role?.toString()=="org_admin" || this.user.username?.indexOf("_admin") != -1)
      {
        isOK=true;
        window.localStorage.setItem(CookieService.SESSION_USER_GROUP,'Country');
        window.localStorage.setItem(CookieService.SESSION_ADMIN_GROUP,'Admin');
        window.localStorage.setItem(CookieService.SESSION_VIEW_GROUP,'Both');
      }
      else if(this.user.groups.filter(gr => gr.owner != this.user.username && gr.id === ConfigService.getConfig().agol.privateSectorViewersGroupId).length > 0)
      {
        isOK=true;
        window.localStorage.setItem(CookieService.SESSION_USER_GROUP,'PrivateSector');
        window.localStorage.setItem(CookieService.SESSION_ADMIN_GROUP,'');
        window.localStorage.setItem(CookieService.SESSION_VIEW_GROUP,'ViewOnly');
      }
      else
      {
      //isOK = this.user.groups.filter(gr => gr.id === ConfigService.getConfig().agol.editorsGroupId).length > 0;
        if(this.user.groups.filter(gr => gr.id === ConfigService.getConfig().agol.editorsGroupId).length > 0)
        {
          isOK=true;
          window.localStorage.setItem(CookieService.SESSION_USER_GROUP,'Country');
          window.localStorage.setItem(CookieService.SESSION_ADMIN_GROUP,'');
        }
        if(this.user.groups.filter(gr => gr.id === ConfigService.getConfig().agol.privateSectorEditorsGroupId).length > 0)
        {
          isOK=true;
          window.localStorage.setItem(CookieService.SESSION_USER_GROUP,'PrivateSector');
          window.localStorage.setItem(CookieService.SESSION_ADMIN_GROUP,'');
        }
         if(this.user.groups.filter(gr => gr.id === ConfigService.getConfig().agol.editorsGroupId).length > 0 && this.user.groups.filter(gr => gr.id === ConfigService.getConfig().agol.privateSectorEditorsGroupId).length > 0)
        {
           isOK=true;
           window.localStorage.setItem(CookieService.SESSION_USER_GROUP,'Country');
          window.localStorage.setItem(CookieService.SESSION_VIEW_GROUP,'Both');
        }
      }
    }

    return isOK;
  }

  /**
   * Init service instance
   */
  public static initInstance(): void {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }

    AuthService.instance.initUserFromCookie();
  }

  /**
   * Get service instance
   */
  public static getInstance(): AuthService {
    return AuthService.instance;
  }


  /**
   * Authenticate esri user
   * @param login
   * @param pass 
   */
  public async authenticateUser(login: string = '', pass: string = ''): Promise<boolean> {
    
    try {

      // 1) SSO Login
      if(!login && !pass) {
        this.session = await UserSession.beginOAuth2({
          clientId: ConfigService.getConfig().agol.authentification.clientId,
          redirectUri: ConfigService.getConfig().agol.authentification.redirectUri,
          portal: `${ConfigService.getConfig().agol.portalURL}/${ConfigService.getConfig().agol.authentification.portal}`,
          provider: 'arcgis',
          popup: ConfigService.getConfig().agol.authentification.popup
        });
      }

      // 2) Arcgis Loging
      else {
        this.session = new UserSession({
          username: login,
          password: pass,
          portal: `${ConfigService.getConfig().agol?.portalURL ?? ''}/${ConfigService.getConfig().agol?.signinPath ?? ''}`
        });
      }

      if(this.session) {
        return await this.initSession(this.session);
      } else {
        this.session = undefined;
        return false;
      }
    }

    catch(err: any) {
      return Promise.reject(err);
    }
  }

  /**
   * Init the session
   * @param session
   * @returns
   */
  public async initSession (session: UserSession): Promise<boolean> {
    let isOK = false;

    if (session) {
      this.session = session;

      this.user = await this.session.getUser();
      if (this.user && this.user.role && this.checkUserGroup()) {

        CookieService.getInstance().setCookie({
          user: this.user, 
          session: this.session.serialize(), 
          tokenExpires: this.session.tokenExpires.toUTCString()
        });
        isOK = true;
      } else {
        this.session = undefined;
        isOK = false;
      }
    }

    return Promise.resolve(isOK);
  }

  /**
   * Check connected user
   * @returns 
   */
  public static checkConnectedUser(): boolean {
    if(!AuthService.getInstance()) {
      AuthService.initInstance();
    }
    return AuthService.getInstance() && AuthService.getInstance().user && AuthService.getInstance().session !== undefined;
  }
}
